<template>
  <div class="childRank">
    <div class="header">
      <div class="title"><i></i><span>排行榜</span></div>
      <div class="desc">以总保费为标准进行排名</div>
    </div>
    <div class="contentTable">
      <el-table v-loading="loading" :data="tableData" stripe border class="omtable" style="width: 100%" tooltip-effect="dark">
        <el-table-column type="index" min-width="80"></el-table-column>
        <el-table-column prop="name" label="员工姓名" min-width="140" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="mobile" label="电话" min-width="120" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="createTime" label="入驻时间" min-width="140" show-overflow-tooltip>
          <template slot-scope="scope">
            {{scope.row.createTime|timeSubstr(0,16)}}
          </template>
        </el-table-column>
        <el-table-column prop="customNum" label="客户数（人）" min-width="100" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="policyNum" label="出单数" min-width="100" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="totleFee" label="总保费（元）" min-width="120" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="操作" fixed="right" key="right" v-if="checkAuth('orderList')">
          <template slot-scope="scope">
            <el-button type="text" @click="godetail(scope.row)">查看详情</el-button>
          </template>
        </el-table-column>
        <emptyBox slot="empty"></emptyBox>
      </el-table>
    </div>
  </div>
</template>
<script>
import {common} from "@/api/mixins";
//当前实例组件
export default {
  mixins: [common],
  data: () => ({
    tableData: [],
    loading: false,
    level:'', // 当前选择节点的类型，1一级机构，2二级机构，无数为部门
    id:"",
  }),
  components: {},
  created() {
    this.level = this.$route.query.level
    this.id=this.$route.query.id
    this.querySubRank()
  },
  methods: {
    querySubRank: function () {
      let param = {}
      param.queryDirectly='1'
      // 二级机构传mechanId，部门传deptId
      if(this.level==2 || this.level == 1){
        param.mechanId=this.id
        param.departmentId='0'
      }else if(!this.level){
        param.departmentId=this.id
      }
      // 删除空参
      this.$tools.delNull(param)
      var that = this
      that.loading = true
      this.$http({
        url: '/master/subAccount/querySubRank',
        type: 'put',
        params: param,
      })
        .then(function (data) {
          that.loading = false
          that.tableData = data.data
        })
        .catch((e) => {
          that.loading = false
        })
    },
    godetail: function (row) {
      this.$router.push({
        path: '/childAchiev',
        query: {
          id: row.mechanId,
          mobile: row.mobile,
          name: row.name,
        },
      })
    },
  },
  mounted() {},
}
</script>
<style lang="scss">
.childRank {
  background: #fff;
  min-height: 800px;
  padding: 20px 40px;
  .header {
    i {
      display: inline-block;
      width: 5px;
      height: 16px;
      vertical-align: middle;
      background: #ff9700;
    }
    span {
      font-size: 16px;
      vertical-align: middle;
      margin-left: 10px;
    }
    .desc {
      padding-left: 15px;
      margin-top: 10px;
      color: #666;
      font-size: 14px;
    }
  }
  .contentTable {
    margin-top: 20px;
  }
}
</style>
